import {BasePageLayout} from "../components/grouping/BasePageLayout";
import {useClubs} from "../api/clubapi";
import {useProvinces} from "../api/provinceApi";
import {Section} from "../components/grouping/Section";
import {Button, Col} from "react-bootstrap";
import Collapse from 'react-bootstrap/Collapse';
import {useState} from "react";
import {useMembers} from "../api/memberapi";
export function ClubPage(props) {
    const {clubs} = useClubs();
    const {members} = useMembers();
    const {provinces} = useProvinces();

    const clubsFiltered = clubs?.filter(c=> c.active === true);

    return <BasePageLayout title={'Clubs'}>
        {provinces?.map(p => <ProvinceItem key={p.id} clubs={clubsFiltered} members={members} province={p}/>)}
    </BasePageLayout>
}


function ProvinceItem(props) {
    const {province, members, clubs} = props;
    const [open, setOpen] = useState(false);
    const clubsFilteredOnProvinceSectors = clubs?.filter(c => c.provincie === province.title);
    const distinctSectors = Array.from(new Set(clubsFilteredOnProvinceSectors?.map(cfops => cfops?.sector)))
    return <Section className={"g-0 mt-2"}>
        <Col>
            <Button className={"text-decoration-none btn-light"} variant={"link"} onClick={() => setOpen(!open)}>
                <InfoText contentClassName={"text-primary"} title={"Provincie"} content={province?.title}/>
            </Button>
            <Collapse in={open}>
                <Section>
                    {distinctSectors?.map(ds => <SectorItem key={ds.id} members={members} clubs={clubs} sector={ds}/>)}
                </Section>
            </Collapse>
        </Col>
    </Section>
}

function SectorItem(props) {
    const {sector, clubs, members} = props;
    const [open, setOpen] = useState(false);
    const clubsFilteredOnSector = clubs?.filter(c => c.sector === sector)
    return <Col xs={12}>
        <Button variant={"link"} className={"ms-3 text-decoration-none btn-light  btn-warning mt-2 text-black"}
                onClick={() => setOpen(!open)}>
            <InfoText contentClassName={"text-primary"} title={"Sector"} content={sector}/>
        </Button>
        <Collapse in={open}>
            <Section>
                {clubsFilteredOnSector?.map(c => <ClubItem key={c.id} members={members} club={c}/>)}
            </Section>
        </Collapse>
    </Col>
}


function ClubItem(props) {
    const {club, members} = props
    const [open, setOpen] = useState(false);
    const voorzitter = members?.filter(m => m.clubNr === Number(club.stamNummer) && m.voorzitter === true)
    const secretaris = members?.filter(m => m.clubNr === Number(club.stamNummer) && m.secretaris === true)

    return <Col xs={12}>
        <Button variant={"link"} className={"ms-5 text-decoration-none btn-light  btn-warning mt-2 text-black"}
                onClick={() => setOpen(!open)}>
            <InfoText title={"Club"} content={club?.club}/>
        </Button>
        <Collapse in={open}>
            <div>
                <ClubInfoCard club={club} voorzitter={voorzitter} secretaris={secretaris}/>
            </div>
        </Collapse>
    </Col>
}

function ClubInfoCard(props) {
    const {voorzitter, secretaris, club} = props
    return <Section className={"shadow m-4 p-3 rounded-2"}>
        {voorzitter?.map(v => <InfoText key={v.id} title={"Voorzitter"} content={`${v?.naam} ${v?.voornaam}`}/>)}
        {secretaris?.map(s => <InfoText key={s.id} title={"Secretaris"} content={`${s?.naam} ${s?.voornaam}`}/>)}
        <InfoText title={"Adres"} content={club?.adres}/>
        <InfoText title={"Gemeente"} content={club?.adres2}/>
        <InfoText title={"lokaal"} content={club?.lokaal}/>
        <InfoText title={"Tel"} content={club?.telefoon}/>
        <InfoText title={"Email"} content={club?.email}/>

    </Section>
}


export function InfoText(props) {
    const {title, content, contentClassName} = props;
    return <p style={{color: "black", fontSize: "large", fontWeight: "bold"}}>{title ? `${title}   ` : ""}<span
        className={contentClassName ? contentClassName : ""}
        style={{fontSize: "medium", fontWeight: "normal"}}>{content ? content : " "}</span></p>
}